import * as React from "react";
import { useCallback, useContext, useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { DEFAULT_HIGHLIGHT_COLOR } from "views/Constants";
import HighlightingRulesContext from "views/components/contexts/HighlightingRulesContext";
import IconButton from "components/common/IconButton";
import { SortableList } from "components/common";
import HighlightingRuleClass from "views/logic/views/formatting/highlighting/HighlightingRule";
import HighlightingRule, { Container, RuleContainer } from "./HighlightingRule";
import ColorPreview from "./ColorPreview";
import HighlightForm from "./HighlightForm";
import SectionInfo from "../SectionInfo";
import SectionSubheadline from "../SectionSubheadline";
const SortableHighlightingRule = ({ item: { id, rule }, dragHandle, className = void 0, onUpdate, onDelete }, ref) => /* @__PURE__ */ React.createElement(
  HighlightingRule,
  {
    key: id,
    rule,
    onUpdate,
    onDelete,
    dragHandle,
    className,
    ref
  }
);
const SortableHighlightingRuleWrapper = forwardRef(SortableHighlightingRule);
const HighlightingRules = ({
  description,
  onUpdateRules,
  onCreateRule: onCreateRuleProp,
  onUpdateRule,
  onDeleteRule,
  showSearchHighlightInfo = true
}) => {
  var _a;
  const { t } = useTranslation("search");
  const [showForm, setShowForm] = useState(false);
  const rules = (_a = useContext(HighlightingRulesContext)) != null ? _a : [];
  const rulesWithId = rules.map((rule) => ({
    rule,
    id: `${rule.field}-${rule.value}-${rule.color}-${rule.condition}`
  }));
  const updateRules = useCallback(
    (newRulesWithId) => {
      const newRules = newRulesWithId.map(({ rule }) => rule);
      return onUpdateRules(newRules);
    },
    [onUpdateRules]
  );
  const onCreateRule = useCallback(
    (field, value, condition, color) => onCreateRuleProp(HighlightingRuleClass.create(field, value, condition, color)),
    [onCreateRuleProp]
  );
  const listItemRender = useCallback(
    (props) => /* @__PURE__ */ React.createElement(SortableHighlightingRuleWrapper, { ...props, onUpdate: onUpdateRule, onDelete: onDeleteRule }),
    [onDeleteRule, onUpdateRule]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionInfo, null, description), /* @__PURE__ */ React.createElement(SectionSubheadline, null, t("sidebar_highlighting.active_highlights"), " ", /* @__PURE__ */ React.createElement(
    IconButton,
    {
      className: "pull-right",
      name: "add",
      onClick: () => setShowForm(!showForm),
      title: t("sidebar_highlighting.add_rule_title")
    }
  )), showForm && /* @__PURE__ */ React.createElement(HighlightForm, { onClose: () => setShowForm(false), onSubmit: onCreateRule }), showSearchHighlightInfo && /* @__PURE__ */ React.createElement(Container, { $displayBorder: !!(rulesWithId == null ? void 0 : rulesWithId.length) }, /* @__PURE__ */ React.createElement(ColorPreview, { color: DEFAULT_HIGHLIGHT_COLOR }), /* @__PURE__ */ React.createElement(RuleContainer, null, t("sidebar_highlighting.search_terms"))), /* @__PURE__ */ React.createElement(SortableList, { items: rulesWithId, onMoveItem: updateRules, customListItemRender: listItemRender }));
};
export default HighlightingRules;
